const Checkbox = ({entity, fld}) => {
    const defaultChangeHandler = (event) => {
        const {checked} = event.target
        if(fld.changeHandler) {
            fld.changeHandler(entity.id, fld.name, checked)
        } else {
            console.log("defaultChangeHandler", fld.name, checked)
        }
    }
    return <input type="checkbox" checked={entity[fld.name]} onChange={defaultChangeHandler} />
}

export default Checkbox